import styled from '@emotion/styled';
import classnames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import colors from 'config/theme/colors';
import { SALES_SEVERITY, SEVERITY } from 'constants/ChecklistConstants';

/** @type {Record<import("@arhs-fleetback/types/entities/checklists").ChecklistSeverity, {className: string, color: string}>} */
const colorAndClass = {
  [SEVERITY.UNDEFINED]: {
    className: 'fb-icon--empty'
  },
  [SEVERITY.NONE]: {
    className: 'fb-icon--circle-check-filled',
    color: colors['@success-color']
  },
  [SEVERITY.LOW]: {
    className: 'fb-icon--issue-filled',
    color: colors['@warning-color-light']
  },
  [SEVERITY.HIGH]: {
    className: 'fb-icon--warning-filled',
    color: colors['@error-color']
  },
  [SEVERITY.OFFERED]: {
    className: 'fb-icon--offered-filled',
    color: colors['@success-color']
  },
  [SALES_SEVERITY.PROPOSED]: {
    className: 'fb-icon--circle-check-filled',
    color: colors['@primary-color']
  }
};

const Icon = styled.i`
    color: ${({ color = colors['@font-grey-light'] }) => color} !important;
`;

/** @type {React.FC<{ severity: import("@arhs-fleetback/types/entities/checklists").ChecklistSeverity } & React.HTMLAttributes<HTMLElement>>} */
const SeverityIcons = ({ severity, ...rest }) => {
  const intl = useIntl();
  const exists = colorAndClass[severity] !== undefined;
  const { color, className } = colorAndClass[severity] ?? {};

  const title = exists
    ? { id: `app.severities.${severity}`, defaultMessage: severity }
    : { id: 'unknown', defaultMessage: 'Unknown' };

  return (
    <Icon
      color={color}
      title={intl.formatMessage(title)}
      {...rest}
      className={classnames([rest.className, className])}
    />
  );
};

export default SeverityIcons;
